import AgentsLiveboard from 'models/liveboards/agents_liveboard';
import LiveboardType from './liveboard_type';
import SummaryLiveboard from 'models/liveboards/summary_liveboard';
import TopicsLiveboard from 'models/liveboards/topics_liveboard';

export default [
  [LiveboardType.AGENTS, AgentsLiveboard],
  [LiveboardType.SUMMARY, SummaryLiveboard],
  [LiveboardType.TOPICS, TopicsLiveboard],
];



// WEBPACK FOOTER //
// ./src/scripts/domain/models/liveboards/liveboard_classes.js